export const getListOf = (n) => Array.from({ length: n }, (_, i) => i + 1)
